import { render } from "./ContentPublishHistory.vue?vue&type=template&id=5e1dc4d2&scoped=true&ts=true"
import script from "./ContentPublishHistory.vue?vue&type=script&lang=ts"
export * from "./ContentPublishHistory.vue?vue&type=script&lang=ts"

import "./ContentPublishHistory.vue?vue&type=style&index=0&id=5e1dc4d2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1dc4d2"]])

export default __exports__